import { useNavigate, useParams } from "react-router";
import styles from './ProductCosts.module.scss';
import ChannelFilter from "../components/channelFilter/ChannelFilter";
import { useAppSelector } from "../../../redux/reduxHooks";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { RestS } from "../../../rest/rest-service";
import { MetricValueType, TaxInputInf, TaxTypes } from "../../../interfaces/interfaces";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import React from "react";
import { btnSpanStyle, filterColdState } from "./ProductCosts";
import { PaginationState, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { formatNumberWithComma, getLast12CYMonthsArr, onBlurFormatNumber } from "../../../components/functions/utilities";
import { IoSearch as SearchIcon } from "react-icons/io5";
import { GoPencil as PencilIcon } from "react-icons/go";
import { MdOutlineContentCopy as CopyIcon } from "react-icons/md";
import Drawer from '@mui/material/Drawer';
import { TbArrowNarrowDown as DownArrowIcon, TbArrowNarrowUp as UpArrowIcon } from "react-icons/tb";
import { OverlayTrigger } from 'react-bootstrap';
import { RenderTooltip } from '../../../components/common/RenderTooltip';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { Pagination } from '@mui/material';
import SelectedProductsDrawer from "../components/SelectedProductsDrawer/SelectedProductsDrawer";
import ProductCostsFooter from "../components/ProductCostsFooter/ProductCostsFooter";
import { debounce } from "lodash";
import { HiChevronLeft as LeftArrowIcon } from 'react-icons/hi';
import { PcSectionRoutes } from "../pcSections/PcSections";

type Anchor = 'top' | 'left' | 'bottom' | 'right';


const CopyCosts = () => {

  const { productId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]); // Table data
  const [loading, setLoading] = useState(false); // Loading state
  const [pageData, setPageData] = useState({}); // Cached page data
  // const [pageIndex, setPageIndex] = useState(0); // Current page
  // const [pageSize, setPageSize] = useState(0); // Page size
  const [searchTerm, setSearchTerm] = useState('');
  const [apiSearchTerm, setApiSearchTerm] = useState('');
  const [paginationState, setPaginationState] = useState<PaginationState>({ pageIndex: 0, pageSize: 0 });
  const [searchCleared, setSearchCleared] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const [allProducts, setAllProducts] = useState({});
  const [allProductsLoading, setAllProductsLoading] = useState(false);

  const [isAllProductSelected, setIsAllProductSelected] = useState(false);

  const [currentAllProducts, setCurrentAllProducts] = useState([]);



  const [taxInputDetails, setTaxInputDetails] = useState<{ taxInput: TaxInputInf, showTaxColumn: boolean }>({
    taxInput: null,
    showTaxColumn: false,
  });

  const [showAsinColumn, setShowAsinColumn] = useState(false)

  const [pageLoading, setPageLoading] = useState(true);

  const headerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const row3Ref = useRef(null);

  const [topForRow1, setTopForRow1] = useState(0);
  const [topForRow2, setTopForRow2] = useState(0);
  const [topForRow3, setTopForRow3] = useState(0);

  const [state, setState] = useState({
    right: false,
  });

  const [allFilterState, setAllFilterState] = useState(filterColdState);

  const [productData, setProductData] = useState(null);

  const cachedMonthYear = useMemo(() => {
    return getLast12CYMonthsArr()
  }, [])


  const getProductTableData = async ({ searchTerm = null, integrationPartner = allFilterState.integrationPartner, isMissingCost = allFilterState.onlyMissingCosts, pageIndex = 0, forceReload = false, sorting = allFilterState.sortingState, removeProductId, cachedProductList = null, showLoading = true, isMissingTaxRate = allFilterState.onlyMissingTaxRate, cachedProductListForTaxRate = null, isProductSold = allFilterState.onlyProductSold }) => {
    try {
      // console.log('searchTerm', searchTerm, 'pageIndex', pageIndex, 'forceReload', forceReload, 'cachedProductList', Array.from(cachedProductList ?? cachedProductListMc));
      if (paginationState?.pageIndex in pageData && !forceReload) {
        // console.log('coming inside cache');
        setData(pageData[paginationState?.pageIndex])
        return;
      }
      // const cachedProductMc = []
      if (showLoading) setLoading(true);

      const productTableData: any = await RestS.getProductsData(integrationPartner == "All Channels" ? null : integrationPartner, searchTerm, pageIndex, sorting, true, isMissingCost, removeProductId, null, isMissingTaxRate, null, isProductSold);
      // console.log('response', productTableData);
      //     const { data } = response;
      //     setData(data);

      const latestMonth = cachedMonthYear.shift();

      const formattingProductData = productTableData?.data.map((product) => {
        const prdCost = product.inEffectValue == MetricValueType.apiCost ? product.apiCost : (product.defaultCost && product.defaultCost > 0 && product.monthYear != latestMonth) ? product?.defaultCost : product.updatedCost;  // (product.defaultCost && product.defaultCost > 0 && product.monthYear != latestMonth) - condition to check if updated_cost is from a latest month and if it is not then show the default cost otherwise show updated cost
        const pkgCost = product?.pkgDependentMetric ?
          product?.pkgDependentMetric == "UNIT_COST" ?
            Math.round((product?.packagingCost * prdCost) / 100) :
            Math.round((product?.packagingCost * product?.price) / 100)
          : product?.packagingCost
        return {
          ...product,
          productCost: prdCost,
          sellingPrice: product.price,
          packagingCost: pkgCost
        }
      })
      console.log("formatting Products Data", formattingProductData);
      setData(formattingProductData);
      // console.log('pageSize', Math.ceil((productTableData?.paginationData.totalCount / productTableData?.paginationData.pageCount)))
      // console.log('pagination state', paginationState)
      // console.log('response', productTableData);
      if (!productTableData?.paginationData?.totalCount) {
        table.setPageCount(0)
      } else {
        const pageCount = Math.ceil((productTableData?.paginationData.totalCount / productTableData?.paginationData.pageCount));
        console.log('pageCount', pageCount);
        table.setPageCount(pageCount);
        // table.setPageSize(pageSize ? pageSize : 1);
        // table.setPageCount(pageCount ? pageCount : 1)
      }
      // setPaginationState({
      //     ...paginationState,
      //     pageSize: Math.ceil((productTableData?.paginationData.totalCount / productTableData?.paginationData.pageCount))
      // })
      setPageData({ ...pageData, [paginationState.pageIndex]: formattingProductData })

      if (forceReload) {
        setAllFilterState(prev => ({ ...prev, forceReload: false }))
      }
      if (showLoading) setLoading(false);
      // setLoading(false);
    } catch (error) {
      if (showLoading) setLoading(false);
      console.log('error', error);
    }

  }

  const getTaxInput = async () => {
    try {
      const { taxInput } = await RestS.fetchTaxInput();
      if (taxInput) {
        setTaxInputDetails({
          taxInput: taxInput,
          showTaxColumn: taxInput?.taxType == TaxTypes.variable,
        })
        return taxInput;
      } else {
        setTaxInputDetails({
          taxInput: taxInput,
          showTaxColumn: false,
        })
        return taxInput;
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const fetchCopyProductData = async (productId: number) => {
    try {
      const { product } = await RestS.fetchProductByid(productId);
      if (!product) {
        console.log('product not found');
        navigate(PcSectionRoutes.productCosts)
      } else {
        const latestMonth = cachedMonthYear.shift();
        setProductData({
          ...product,
          productCost: product.inEffectValue == MetricValueType.apiCost ? product.apiCost : (product.defaultCost && product.defaultCost > 0 && product.monthYear != latestMonth) ? product?.defaultCost : product.updatedCost,  // (product.defaultCost && product.defaultCost > 0 && product.monthYear != latestMonth) - condition to check if updated_cost is from a latest month and if it is not then show the default cost otherwise show updated cost
          sellingPrice: product.price
        });
      }
      return product;
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    (async () => {
      await fetchCopyProductData(Number(productId))
      await getTaxInput();
      setPageLoading(false);
    })()
  }, []);

  const checkIfAllToBeSelected = async (integrationPartner = allFilterState.integrationPartner, searchString = allFilterState.searchString, missingCosts = allFilterState.onlyMissingCosts, missingTaxRate = allFilterState.onlyMissingTaxRate, onlyProductSold = allFilterState.onlyProductSold) => {
    try {
      console.log('coming inside checkIf all to be selected', allFilterState, onlyProductSold)
      const response: any = await RestS.getProductsData(integrationPartner == "All Channels" ? null : integrationPartner, searchString, 1, "ASC", false, missingCosts, null, null, missingTaxRate, null, onlyProductSold);
      if (response?.data) {
        // console.log('response data', response?.data?.length)
        for (const product of response?.data) {
          if (!rowSelection[product.productId]) {
            console.log('checkIfAllToBeSelected', false)
            setIsAllProductSelected(false);
            break;
          }
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const getAllProducts = async () => {
    try {
      if (isAllProductSelected) {
        // console.log('coming inside is All products selected')
        setAllProductsLoading(true);
        // const response: any = await RestS.getProductsData(allFilterState?.integrationPartner == "All Channels" ? null : allFilterState?.integrationPartner, allFilterState?.searchString, 1, "ASC", false, allFilterState.onlyMissingCosts);
        // console.log('response', response);
        if (currentAllProducts) {
          // setAllProducts(response?.data);
          const allProductsObj = currentAllProducts.reduce((prev, curVal) => {
            prev['allProducts'][curVal.productId] = curVal;
            prev['checkedState'][curVal.productId] = isAllProductSelected;
            return prev;
          }, { allProducts: {}, checkedState: {} })

          console.log('original Row Selection', table?.getState().rowSelection);
          console.log('checkedState', allProductsObj?.checkedState)
          // console.log('allProductsObj', allProductsObj);
          setAllProducts(prev => ({ ...prev, ...allProductsObj?.allProducts }));
          table?.setRowSelection({ ...table.getState().rowSelection, ...allProductsObj?.checkedState });
        }
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      setAllProductsLoading(false);
    }
  }

  useEffect(() => {
    // console.log('triggering all Products api call')
    getAllProducts();
  }, [isAllProductSelected]);

  const deselectAllProducts = async () => {
    try {
      // const currentRowSelection = table?.getState().rowSelection;
      // const response: any = await RestS.getProductsData(allFilterState?.integrationPartner == "All Channels" ? null : allFilterState?.integrationPartner, allFilterState?.searchString, 1, "ASC", false, allFilterState.onlyMissingCosts);
      if (currentAllProducts) {
        const manipulatedRowSelection = currentAllProducts.reduce((prev, curVal) => {
          prev[curVal.productId] = false;
          return prev;
        }, {})
        table?.setRowSelection({ ...table.getState().rowSelection, ...manipulatedRowSelection });
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const addToAllProduct = useCallback((productData) => {
    setAllProducts(prev => ({ ...prev, [productData.productId]: productData }))
  }, [allProducts, isAllProductSelected]);

  const { integrationPartners } = useAppSelector((state) => state.config);

  const { connectionStatus } = useAppSelector((state) => state.connections);

  const ipConfigs = useMemo(() => {
    if (integrationPartners != undefined) {
      let configObj = {};
      const connectionStatusSet = new Set(connectionStatus);

      for (const ip of Object.values(integrationPartners)) {
        // console.log('ip', ip)
        const logo = ip['logo'];
        const ipId = ip["_id"]
        // if(connectionStatusSet.has(ip['_id'])) {
        configObj[ip['companyName']] = {
          connectionStatus: connectionStatusSet.has(ipId) ? true : false,
          logo
        };
        // } 
      }
      return configObj;
    } else {
      return {};
    }
  }, [integrationPartners, connectionStatus]);

  useEffect(() => {
    setShowAsinColumn(allFilterState?.integrationPartner == 'All Channels' || allFilterState?.integrationPartner.includes('Amazon Vendor Central'))
  }, [allFilterState?.integrationPartner])

  const columns = useMemo(() => {
    // Define columns for React Table

    const taxRateColumn = taxInputDetails.showTaxColumn ? [
      {
        accessorKey: 'taxRate', // Accessor shows the "key" of the "data" you want to access
        header: () =>
          <>
            <div className={`${styles.headerTitle} ${styles.rightAlign}`}>GST (%)</div>
          </>,
        cell: (info) => (
          <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
            <div className={styles.rowText}>
              {info.getValue() ? onBlurFormatNumber(info.getValue(), 2) : ''}
            </div>
          </div>
        ),
      }
    ] : []

    const asinColumn = showAsinColumn ? [
      {
        accessorKey: 'asin',
        header: () => <div className={styles.headerTitle}>ASIN</div>,
        cell: (info) => (
          <div className={styles.rowContainer}>
            <div className={styles.rowText}>
              {info.getValue()}
            </div>
          </div>
        )
      }
    ] : []

    const columnStateChanges = [
      {
        accessorKey: 'selectedProduct', // Accessor shows the "key" of the "data" you want to access
        header: () => <div className={styles.headerTitle}></div>, // Header, can be a string or a function for a custom component
        cell: ({ row }) => (
          <div className={styles.checkboxTableContainer} onClick={() => {
          }}>
            <input checked={row.getIsSelected()} onChange={(e) => {
              // setSelectedProductState(prev => ({ ...prev, [row.original.productId]: row.original }))
              row.getToggleSelectedHandler()(e)
              if (!e.target.checked) {
                checkIfAllToBeSelected(null, null, null)
              }
              addToAllProduct(row.original)
              // changeSelectedProduct(row.original)
            }} className={styles.checkBoxInput} type='checkbox' />
          </div>
        ),
      }
    ];

    const formattedColumns = [
      ...columnStateChanges,
      {
        accessorKey: 'productName', // Accessor shows the "key" of the "data" you want to access
        header: () =>
          <>
            <div className={`${styles.headerTitle} ${styles.productHeader}`}>Product Name</div>
          </>,
        cell: (info) => (
          <div className={`${styles.rowContainer} ${styles.productContainer}`}>
            <div className={styles.imageContainer}>
              <img src={`${ipConfigs[info.row.original.integrationPartner]['logo']}`} alt="Data Source" />

            </div>
            <div className={styles.rowText}>
              {info.getValue()}
            </div>
          </div>
        ),
      },
      {
        accessorKey: 'variant',
        header: () => <div className={styles.headerTitle}>Variant</div>,
        cell: (info) => (
          <div className={styles.rowContainer}>
            <div className={styles.rowText}>
              {info.getValue()}
            </div>
          </div>
        )
      },
      {
        accessorKey: 'sku',
        header: () => <div className={styles.headerTitle}>SKU</div>,
        cell: (info) => (
          <div className={styles.rowContainer}>
            <div className={styles.rowText}>
              {info.getValue()}
            </div>
          </div>
        )
      },
      ...asinColumn,
      {
        accessorKey: 'productCost',
        header: () => <div className={`${styles.headerTitle} ${styles.rightAlign}`}>Unit Cost (₹)</div>,
        cell: (info) => (
          <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
            <div className={styles.rowText}>
              {info.getValue() ? formatNumberWithComma(info.getValue(), 1) : ''}
            </div>
          </div>
        )
      },
      {
        accessorKey: 'packagingCost',
        header: () => <div className={`${styles.headerTitle} ${styles.rightAlign}`}>Packaging Cost (₹)</div>,
        cell: (info) => {
          return (
            <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
              <div className={styles.rowText}>
                {info.getValue() ? formatNumberWithComma(info.getValue(), 1) : ''}
              </div>
            </div>
          )
        }
      },
      ...taxRateColumn,
      {
        accessorKey: 'quantity',
        header: () => <div className={`${styles.headerTitle} ${styles.sortingHeader} ${styles.rightAlign}`}>
          <div className={styles.sortingTitle}>
            Units Sold
          </div>
          <div className={styles.sortingIconContainer} onClick={() => {
            setPageData({})
            setAllFilterState({
              ...allFilterState,
              forceReload: true,
              sortingState: allFilterState.sortingState == "ASC" ? "DESC" : "ASC"
            });
            table.resetPagination();
          }}>
            {allFilterState.sortingState == "ASC" ? <DownArrowIcon /> : <UpArrowIcon />}
          </div>
        </div>,
        cell: (info) => (
          <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
            <div className={styles.rowText}>
              {info.getValue() ? formatNumberWithComma(info.getValue()) : ''}
            </div>
          </div>
        )
      },
    ];


    return formattedColumns;
  },
    [ipConfigs, isAllProductSelected, allFilterState, taxInputDetails]
  );


  // Create a table instance
  const table = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    enableRowSelection: true,
    // Define manual pagination states and functions
    manualPagination: true, // React Table v8 doesn't use usePagination anymore
    pageCount: -1, // Calculate the total page count
    state: {
      pagination: paginationState,
      rowSelection
    },
    onRowSelectionChange: setRowSelection,
    onPaginationChange: setPaginationState,
    getRowId: (row, relativeIndex, parent) => row.productId,
  });

  const debouncedSearch = useMemo(() => {
    return debounce((newSearchTerm) => {
      table.setPageIndex(0);
      setPageData({});

      // setApiSearchTerm(newSearchTerm);
      if (isAllProductSelected) {
        checkIfAllToBeSelected(null, newSearchTerm, null);
      }
      // console.log('allFilterState', allFilterState)
      setAllFilterState({
        ...allFilterState,
        forceReload: true,
        searchString: newSearchTerm
      })
    }, 500);
  }, [table?.getState().pagination?.pageIndex, isAllProductSelected, allFilterState]);

  // Effect for handling search term changes
  useEffect(() => {
    if (apiSearchTerm) {
      debouncedSearch(apiSearchTerm);
    }
  }, [apiSearchTerm]);

  // Effect for fetching data
  useEffect(() => {
    // console.log('paginationState', paginationState)
    // console.log('triggering from use Effect');
    // console.log('allFilterState', allFilterState)
    getProductTableData(
      {
        searchTerm: allFilterState?.searchString, integrationPartner: allFilterState.integrationPartner,
        isMissingCost: allFilterState.onlyMissingCosts,
        pageIndex: paginationState.pageIndex,
        forceReload: allFilterState.forceReload,
        sorting: allFilterState.sortingState,
        isProductSold: allFilterState?.onlyProductSold,
        removeProductId: productId,
      });

  }, [allFilterState?.integrationPartner,
  allFilterState?.onlyMissingCosts,
  allFilterState?.onlyMissingTaxRate,
  allFilterState?.sortingState,
  allFilterState?.searchString,
  allFilterState?.forceReload,
  allFilterState?.onlyProductSold,
  table?.getState().pagination?.pageIndex,
    productId
  ]);

  const getCurrentFilterAllProducts = async () => {
    try {
      // if (isAllProductSelected) {
      // console.log('coming inside is All products selected')
      // setAllProductsLoading(true);
      const response: any = await RestS.getProductsData(allFilterState?.integrationPartner == "All Channels" ? null : allFilterState?.integrationPartner,
        allFilterState?.searchString, 1, "ASC",
        false, allFilterState.onlyMissingCosts, productId, null, allFilterState?.onlyMissingTaxRate, null, allFilterState?.onlyProductSold);
      // console.log('response', response);
      if (response?.data) {
        setCurrentAllProducts(response?.data);
      }
      // }
    } catch (error) {
      console.log('error', error)
    } finally {
      setAllProductsLoading(false);
    }
  }

  useEffect(() => {
    getCurrentFilterAllProducts()
  }, [allFilterState])






  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        // console.log('asdasd')
        if (
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };

  const calculateHeights = () => {
    let totalHeight = 0;
    // console.log('headerRef', headerRef)
    if (headerRef.current) {
      totalHeight += headerRef.current.offsetHeight;
      // console.log('row1 offset', headerRef.current.offsetHeight);
    }
    setTopForRow1(totalHeight);

    if (row1Ref.current) {
      totalHeight += row1Ref.current.offsetHeight;
      // console.log('row2 offset', row1Ref.current.offsetHeight);
    }
    setTopForRow2(totalHeight);

    if (row3Ref.current) {
      totalHeight += row2Ref.current.offsetHeight;
    }
    setTopForRow3(totalHeight);
  };

  useEffect(() => {
    // if (headerRe f?.current) {
    if (!pageLoading) {
      requestAnimationFrame(() => {
        calculateHeights();
      });
    }
    // }
  }, [data, pageLoading]);





  const changeSelectedChannel = async (value) => {
    // console.log('value', value);
    setPageData({});
    // setSelectedChannel(value)
    setAllFilterState({
      ...allFilterState,
      forceReload: true,
      integrationPartner: value
    })
    table.setPageIndex(0);
    // console.log('allState', table?.getIsAllPageRowsSelected());
    let initialAllSelected = false;
    if (isAllProductSelected) {
      // console.log('allPage row was select', table?.getIsAllPageRowsSelected())
      // table.resetRowSelection();
      initialAllSelected = true;
      checkIfAllToBeSelected(value, null, null);
    }
    const data = await getProductTableData({
      searchTerm: allFilterState.searchString,
      integrationPartner: value,
      isMissingCost: allFilterState.onlyMissingCosts,
      pageIndex: 0,
      forceReload: true,
      sorting: allFilterState.sortingState,
      isProductSold: allFilterState?.onlyProductSold,
      removeProductId: productId
    });
  }

  const generateEmptyTds = (count: number) => {
    const tds = [];
    const tdArray = new Array(count).fill('');
    tdArray.forEach((_, i) => {
      tds.push(<td></td>)
    })
    return tds;
  }

  const selectedRows = useMemo(() => {

    // console.log('rowSelection', rowSelection);
    const selectedProducts = Object.values(rowSelection).filter(item => item == true);

    return selectedProducts.length;

  }, [rowSelection]);

  const cancelProductCost = () => {
    navigate(PcSectionRoutes.productCosts);
  }

  const applyProductCosts = async () => {
    try {
      const selectedRows = table.getState().rowSelection;
      const selectedRowsIds = Object.keys(selectedRows).filter((productId) => {
        if (selectedRows[productId]) return true;
        else return false;
      });
      const apiBody = {
        fromProduct: {
          productId: productData.productId,
        },
        toProductIds: selectedRowsIds,
        filter: {
          selectedIntegrationPartner: null,
          search: searchTerm,
          onlyMissingCosts: false
        },
        isAllSelected: false,
        showTaxColumn: taxInputDetails.showTaxColumn
      }
      const data = await RestS.copyProductCosts(apiBody);
      if (data) {
        cancelProductCost();
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  // console.log('topRow1', topForRow1, 'topRow2', topForRow2, 'topRow3', topForRow3)


  return (
    <div className={styles.productCostsRootContainer}>
      {pageLoading ?
        <div className={styles.loadingContainer}>
          <CircularLoader />
        </div> :
        <>
          <div className={styles.headerBtnRootContainer}>
            <div className={styles.leftContainer}>
              <MeritoButton onClick={() => {
                cancelProductCost();
              }} size='md' type='secondary-1' btnText='Back' icon={<LeftArrowIcon />} />

              <div className={styles.separator}></div>
              <div className={styles.productCopyHeading}>
                Duplicate Product Costs
              </div>
            </div>
            <div className={styles.rightContainer}>

              <MeritoButton onClick={cancelProductCost} size='md' type='tertiary' btnText='Cancel' />
              <MeritoButton disabled={selectedRows > 0 ? false : true} onClick={applyProductCosts} size='md' type='primary-1' btnText='Save New Costs' />
            </div>
          </div>

          <div className={styles.topContainer}>
            <div className={styles.leftContainer}>
              <div className={styles.fieldContainer}>
                <div className={styles.labelText}>
                  Sales Channel
                </div>
                <ChannelFilter ipConfig={ipConfigs} selectedValue={allFilterState?.integrationPartner} changeSelectedValue={changeSelectedChannel} />
              </div>
              <div className={styles.fieldContainer}>
                <div className={styles.labelText}>
                  Search for Products
                </div>

                <div className={styles.searchRootContainer}>
                  <div className={styles.searchIcon}>
                    <SearchIcon />
                  </div>

                  <input placeholder='Product Name, Variant, SKU' className={styles.searchInput} type="text" value={apiSearchTerm} onChange={(e) => {
                    if (e.target.value) {
                      // setSearchTerm(e.target.value);
                      setApiSearchTerm(e.target.value);
                      // setAllFilterState({
                      //     ...allFilterState,
                      //     searchString: e.target.value
                      // })
                    } else {
                      // console.log('running this');
                      setSearchCleared(true);
                      setPageData({});
                      setAllFilterState({
                        ...allFilterState,
                        forceReload: true,
                        searchString: ''
                      })
                      setApiSearchTerm('');
                      // setSearchTerm('');
                      table.setPageIndex(0);
                      checkIfAllToBeSelected(null, '', null)
                    }
                  }} />
                </div>


              </div>

              <div className={styles.checkboxRootContainer}>
                <div className={styles.checkboxLabelText}>
                  Filter Products
                </div>
                <div className={styles.checkboxFieldContainer}>
                  <div className={styles.checkboxContainer}>
                    <div className={styles.checkbox}>
                      <input checked={allFilterState.onlyMissingCosts} onChange={(e) => {
                        setPageData({})
                        setAllFilterState({
                          ...allFilterState,
                          forceReload: true,
                          onlyMissingCosts: e.target.checked
                        })
                        table.resetPagination();
                        checkIfAllToBeSelected(null, null, e.target.checked)
                      }} type="checkbox" />
                    </div>
                    <div className={styles.checkboxLabel}>
                      Missing Unit Cost
                    </div>
                  </div>

                  {taxInputDetails?.showTaxColumn ? <div className={styles.checkboxContainer}>
                    <div className={styles.checkbox}>
                      <input checked={allFilterState.onlyMissingTaxRate} onChange={(e) => {
                        setPageData({})
                        setAllFilterState({
                          ...allFilterState,
                          forceReload: true,
                          onlyMissingTaxRate: e.target.checked
                        })
                        table.resetPagination();
                        checkIfAllToBeSelected(null, null, null, e.target.checked)
                      }} type="checkbox" />
                    </div>
                    <div className={styles.checkboxLabel}>
                      Missing GST
                    </div>
                  </div> : null}

                  <div className={styles.checkboxContainer}>
                    <div className={styles.checkbox}>
                      <input checked={allFilterState.onlyProductSold} onChange={(e) => {
                        setPageData({})
                        setAllFilterState({
                          ...allFilterState,
                          forceReload: true,
                          onlyProductSold: e.target.checked
                        })
                        table.resetPagination();
                        checkIfAllToBeSelected(null, null, null, null, e.target.checked)
                      }} type="checkbox" />
                    </div>
                    <div className={styles.checkboxLabel}>
                      Sold in the Last 12 Months
                    </div>
                  </div>
                </div>


              </div>
            </div>
            <div className={styles.rightContainer}>
              {selectedRows > 0 ? (['right'] as const).map((anchor) => (
                <React.Fragment key={anchor}>
                  <MeritoButton type='secondary-2' size='md' btnText={<>View Selected Products <span style={btnSpanStyle}>{selectedRows > 0 ? `(${selectedRows})` : ''}</span></>} onClick={toggleDrawer(anchor, true) as any} />
                  <Drawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                  >
                    <SelectedProductsDrawer allProductSelected={isAllProductSelected} allProducts={Object.values(allProducts)} allProductsLoading={allProductsLoading} allFilterState={allFilterState} ipConfig={ipConfigs} closeDrawer={toggleDrawer(anchor, false)} tableState={table} />
                  </Drawer>
                </React.Fragment>
              )) : null}

            </div>
          </div>



          <div className={styles.productTableContainer}>
            <table>
              <thead>
                {table.getHeaderGroups().map((headerGroup, groupIndex) => {
                  return <tr ref={headerRef} key={headerGroup.id}>
                    {headerGroup.headers.map((header, headerIndex) => {
                      return (
                        <>
                          <th>
                            {flexRender(header.column.columnDef.header, header.getContext())}
                          </th>
                        </>
                      )
                    })}
                  </tr>
                })}
              </thead>

              <tbody>
                <>
                  <tr ref={row1Ref} className={styles.copyCostsHeader} style={{ top: `${topForRow1}px` }}>
                    <td></td>
                    <td>Duplicate Costs From</td>
                    {taxInputDetails?.showTaxColumn && showAsinColumn ? generateEmptyTds(7) : taxInputDetails?.showTaxColumn || showAsinColumn ? generateEmptyTds(6) : generateEmptyTds(5)}
                  </tr>
                  <tr ref={row2Ref} className={styles.copyCostsProduct} style={{ top: `${topForRow2}px` }}>
                    <td></td>
                    <td>
                      <div className={`${styles.rowContainer} ${styles.productContainer}`}>
                        <div className={styles.imageContainer}>
                          {productData ? <img src={`${ipConfigs[productData?.integrationPartner]['logo']}`} alt="Data Source" /> : null}

                        </div>
                        <div className={styles.rowText}>
                          {productData?.productName}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={`${styles.rowContainer} `}>
                        <div className={styles.rowText}>
                          {productData?.variant ? formatNumberWithComma(productData?.variant) : ''}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={`${styles.rowContainer} `}>
                        <div className={styles.rowText}>
                          {productData?.sku ? productData?.sku : ''}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
                        <div className={styles.rowText}>
                          {productData?.productCost ? formatNumberWithComma(productData?.productCost, 1) : ''}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
                        <div className={styles.rowText}>
                          {productData?.packagingCost ? formatNumberWithComma(productData?.packagingCost) : ''}
                        </div>
                      </div>
                    </td>
                    {taxInputDetails?.showTaxColumn ? <td>
                      <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
                        <div className={styles.rowText}>
                          {productData?.taxRate ? productData?.taxRate : ''}
                        </div>
                      </div>
                    </td> : null}
                    <td>
                      <div className={`${styles.rowContainer} ${styles.rightAlign}`}>
                        <div className={styles.rowText}>
                          {productData?.quantity ? formatNumberWithComma(productData?.quantity) : ''}
                        </div>
                      </div>
                    </td>

                  </tr>
                  <tr ref={row3Ref} className={styles.copyCostsHeader} style={{ top: `${topForRow3}px` }}>
                    <td>
                      <div className={styles.checkboxTableContainer} onClick={() => {
                      }}>
                        <input
                          checked={isAllProductSelected}
                          onChange={(e) => {
                            setIsAllProductSelected(prev => !prev);
                            if (!e.target.checked) {
                              deselectAllProducts();
                            }
                          }}
                          // checked={table.getIsAllRowsSelected()}
                          //  onChange={table.getToggleAllRowsSelectedHandler()}
                          className={styles.checkBoxInput} type='checkbox' />
                      </div>
                    </td>
                    <td>To</td>
                    {taxInputDetails?.showTaxColumn && showAsinColumn ? generateEmptyTds(7) : taxInputDetails?.showTaxColumn || showAsinColumn ? generateEmptyTds(6) : generateEmptyTds(5)}
                  </tr>
                </>
                {loading ? null : table.getRowModel().rows.map(row => {
                  return (
                    <tr key={row.id}>
                      {row.getVisibleCells().map(cell => {
                        return (
                          <td key={cell.id}>
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {loading ?

              <div className={styles.loaderContainer}>
                <CircularLoader />
              </div> : !table.getRowModel().rows.length ?
                <div className={styles.coldStateContainer}>
                  <div className={styles.coldStateText}>
                    No Products match your search criteria.
                  </div>
                </div> : null}

          </div>

          <ProductCostsFooter table={table} />
        </>
      }
    </div>
  );
}

export default CopyCosts;